import { View } from 'react-native';
import { Slot } from 'expo-router';

export default function Layout() {
  return (
    <View className={styles.root}>
      <Slot />
    </View>
  );
}

const styles = {
  root: 'flex-1 bg-accentSecondary10 lg:bg-neutral20',
};
